import { render, staticRenderFns } from "./ReVisitationCallback.vue?vue&type=template&id=2a4e60ae&scoped=true&"
import script from "./ReVisitationCallback.vue?vue&type=script&lang=js&"
export * from "./ReVisitationCallback.vue?vue&type=script&lang=js&"
import style0 from "./ReVisitationCallback.vue?vue&type=style&index=0&id=2a4e60ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e60ae",
  null
  
)

export default component.exports